import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import LabeledValue from '../components/LabeledValue'
import Hideable from '../components/Hideable'

const useStyles = makeStyles(() => ({
  augmentation: {
    borderBottom: '1px solid var(--color-neutral-600)',
    paddingBottom: '.5rem'
  },
  codeBlock: {
    backgroundColor: 'var(--color-neutral-500)',
    padding: '1rem',
    whiteSpace: 'pre'
  },
  item: {
    marginBottom: '.5rem',
    paddingLeft: '.5rem',
    borderLeft: '2px solid var(--color-neutral-600)'
  }
}))

const ObjectMappingAugmentations = ({ mapping }) => {
  const classes = useStyles()
  const sortedTransformations = useMemo(() => {
    return [...mapping.augmentations].sort((a, b) => {
      return a.ordinal - b.ordinal
    })
  }, [mapping.augmentations])
  const noItems = sortedTransformations.length ? null : <div>No Augmentations</div>

  return (
    <section className={classes.augmentation}>
      <Hideable label='Augmentations'>
        {noItems}
        {sortedTransformations.map(augmentation => (
          <div key={augmentation.objectAugmentationId} className={classes.item}>
            <LabeledValue label='objectAugmentationId'>{augmentation.objectAugmentationId}</LabeledValue>
            <LabeledValue label='Code'>{augmentation.code}</LabeledValue>
            <LabeledValue label='Description'>{augmentation.description}</LabeledValue>
            <LabeledValue label='Ordinal'>{augmentation.ordinal}</LabeledValue>
            <div className={classes.codeBlock}>
              <code dangerouslySetInnerHTML={{ __html: augmentation.query }} />
            </div>
          </div>
        ))}
      </Hideable>
    </section>
  )
}

ObjectMappingAugmentations.propTypes = {
  mapping: PropTypes.shape({
    augmentations: PropTypes.arrayOf(PropTypes.shape({
      objectAugmentationId: PropTypes.number,
      code: PropTypes.string,
      description: PropTypes.string,
      query: PropTypes.string,
      ordinal: PropTypes.number
    }))
  })
}

export default ObjectMappingAugmentations
